import { Breakpoints, DesignTokenSize, css, styled } from '@volkswagen-onehub/components-core';

export type ResponsiveGaps = {
  readonly [key in Breakpoints]?: DesignTokenSize;
};

export interface VerticalSpacerProps {
  readonly gap: DesignTokenSize | ResponsiveGaps;
}

export const VerticalSpacer = styled.div<VerticalSpacerProps>`
  & > * {
    margin-top: ${(props) => typeof props.gap === 'string' && props.theme.size[props.gap]} !important;

    ${(props) =>
    typeof props.gap !== 'string' &&
      Object.entries(props.gap).map(
        ([breakpoint, gap]) =>
          gap &&
          css`
            @media (min-width: ${breakpoint}px) {
              margin-top: ${props.theme.size[gap]};
            }
          `
      )}

    &:first-child {
      margin-top: initial !important;
    }
  }
`;
